<template>
  <div class="container_newDetail">
    <div class="container">
      <h3>{{newData.title}}</h3>
      <div class="subTitle">发布于：{{newData.dateTime}}</div>
      <div v-if="topImg">
        <div class="img" :style="{background:'url('+newData.img+') no-repeat',backgroundSize:'cover'}"></div>
      </div>
      <div class="content">
        <p class="summary">{{newData.summary}}</p>
        <div class="article" v-html="newData.content"></div>

      </div>
    </div>
  </div>
</template>

<script>
import newImg1 from '../../../assets/new_01.jpg'
import newImg2 from '../../../assets/new_02.jpg'
import newImg3 from '../../../assets/new_03.jpg'
import newImg0 from '../../../assets/news_00.png'
import article from '../../../assets/artitle02.png'
import casePic1 from '../../../assets/case_01.jpg'
import casePic2 from '../../../assets/case_02.jpg'
import casePic3 from '../../../assets/case_03.jpg'
let dataSource = {
  newsSource: [{
    id: 0,
    img: '',
    title: '嘉信保险经纪山东平阴分公司9.12开业庆典',
    summary: '“时维九月，序属三秋”，在这样一个充满收获和希望的季节里，嘉信保险经纪山东平阴分公司的家人们怀着无比激动，无比自豪的心情共同见证了这一重要的历史时刻：嘉信保险经纪平阴分公司正式成立！',
    dateTime: '2018-09-01',
    content: '<img src="'+newImg0+'" style="display:block;height:292px;margin:0 auto;"/><p>辛勤的耕耘是收获之本，良好的付出是成才之道，嘉信保险经纪平阴分公司自筹备之日起，深谙省公司的发展方向和策略，分公司全体员工在负责人谭晓晨总的号召下以“做平阴市场最专业的经纪公司，为客户选择最好的产品和最优质的服务”为己任，致力于成为平阴“家喻户晓，值得信赖”的保险经纪公司为发展愿景，孜孜不倦的奔走于平阴地区的大街小巷，为广大的平阴客户送去了全面的家庭风险保障解决方案，最终获得了客户的一致好评。专业用心，做好服务的同时，也收获了自己应有的劳动成果，平阴分公司仅用时三个月，平台人力即突破千人，业务平台月月保持全省前列，并在七八联动时荣获“嘉信齐鲁第一分”的荣誉称号。</p><img src="'+article+'" style="display:block;height:292px;margin:0 auto;"/><p>感恩知报，永久之道，平阴分公司在9月12日开业之际，首先想到的就是大力支持自己的平阴广大客户，在分公司谭总的号召下，全体员工自九月初，就开始准备相应的开业庆典事宜，从最开始的客户分析，电话邀约，请柬亲送，重要客户总经理的亲访，整个庆典流程的校对、彩排等都做了细致的安排和分工，力争让每个客户都能感受到嘉信平阴员工的温暖，在如此细致周到的安排下，与会客户达到了接近两百人。山东分公司总经理王清喜先生对本次庆典发表了热情洋溢的开幕词，充分肯定了经纪模式下以客户需求为导向服务的重要性和必须性。山东分公司寿险总经理丁祥初先生在会上再次深刻剖析了经纪公司对于主体保险公司产品甄选的标准，家庭综合保障解决方案的优势，充分让嘉信的客户在未来不管是家庭保障，还是财务规划等方面都能有效的解决医疗支出，大病保障，孩子教育，养老规划等潜在的风险，在丁总详细的解说下，与会的客户频频鼓掌赞同，其中有68位客户纷纷表示准备再次考虑家庭财务规划方面的建议，并预约好相应的时间，进行详细的了解。</p>'
  },{
    id: 1,
    img: newImg1,
    title: '车险费改再陷怪圈 肉都被渠道吃了...',
    summary: '4月中下旬，多份涉及车险费率市场化改革的文件已下发至保险公司，而在前期两批共18个地区试点之后，商业车险费率改革有望全国铺开。去年6月1日起，...',
    dateTime: '2018-09-01',
    content: '<p>4月中下旬，多份涉及车险费率市场化改革的文件已下发至保险公司，而在前期两批共18个地区试点之后，商业车险费率改革有望全国铺开。</p><p> 去年6月1日起，黑龙江、山东等首批6个试点地区试行商业车险改革，今年年初已将试点铺向第二批12个地区。费率改革最早的试点已经接近一年。今年一季度成绩单显示，前十大车险公司的集中度在下降，一季度，首批试点地区车险保费收入为258.66亿元，同比增长11.30%，车险综合成本率同比下降1.32个百分点为94.18%，第二批试点地区车险保费收入为590.90亿元，同比增长12.12%，车险综合成本率为94.37%，同比下降1.66个百分点，较试点前下降2.26个百分点。 不错的成绩单背后，面对6200亿元的车险市场，保险公司有苦说不出，超九成公司车险业务亏损。一位不愿具名的财险公司高层表示，车险费改以来，车的保费在下降，但费用却在上升，而且最近一阶段上升得非常快，目前阶段，公司十分重视理赔，这一环节甚至决定了公司的生死。 消费者、修理厂、配件商甚至保险公司对现状都不满意，正如上述财险公司高层所言，保险公司提供了各项服务，仍然挣扎在亏损的边缘。车险行业综合费用率在30%-40%的区间，保费的30%以上作为渠道费用，个别公司付出的渠道费用甚至达到50%以上，费率市场化在一定程度上加剧市场竞争，使渠道费用进一步加重。“目前对车险行业而言，顶层设计标准要先行，监管层只有制定统一的规则标准，加大业内监管的力度。”中国市场学会风险管理专业委员会主任张学辉在接受时代周报记者采访时指出。另一位不愿具名的保险研究学者则表示，“要想解决目前的困局，还有一个思路，保险公司要转变盈利点，即通过车险等业务获得一个现金流，更多专注于投资来提高收益，而不仅是从保费中赚钱”。</p><h4> 各方不满现状</h4> <p>保监会发布的数据显示，2016年第一季度，首批试点地区车险综合成本率为94.18%，同比下降1.32个百分点，较试点前下降2.09个百分点；第二批试点地区车险综合成本率为94.37%，同比下降1.66个百分点，较试点前下降2.26个百分点。面对这平稳的数据，一位大型财险公司车险业务人员对时代周报记者直言，这或许只是表面上的平静。上述财险公司高层表示，车险费改试点实施后，保险公司的经营状况与此前设想的甚至相反，保费是下降了，但是费用却上升了，而且上升得非常快。来自一份业内交流数据显示，2016年1月，车险综合成本率100.6%，同比上升0.91个百分点；综合赔付率56.81%，同比下降5.44个百分点；综合费用率43.79%，同比上升6.35个百分点；直到3月，这一数据也并无明显变化，综合成本率99.16%，综合赔付率58.14%，综合费用率41.02%。今年1月，也是第二批费改试点的开局之际，保险公司也许想借此抓住宣传窗口期。综合费用率上升，最主要原因是各家公司通过高额补贴来占据市场，其中补贴包括中介的手续费、业务员的激励以及客户的补贴等。该人士举例称，由于部分4S店的新车用户较多，从而形成较高的议价能力，保险公司不想放弃新车保单这一块，就会抬高渠道费，山东甚至河北等个别地区，销售渠道可获得的返点甚至达到50%-55%。 行至今年3月，车险行业综合成本率降至99.16%，理赔部门做了相当大的努力，上述大型财险公司车险业务人员也告诉记者，今年以来，理赔工作尤其难做，这一块比以往不断趋严。上述管理层甚至直言，车险公司从未如此重视理赔这一环节，理赔的同事基本天天加班，领导层也在不断施加压力，因为这一环节已经决定了保险公司未来的命运。尽管如此，目前大家的努力却未得到各方的满意，消费者、修理厂、配件商甚至保险公司，他们对于现状都不满意。首先是消费者，认为我交了1000元的保费当中，有三四百元是其他费用，这个费用对自身而言公平吗？真正用于赔付的可能只有五六百元，消费者者不愿为其他费用买单，而修理厂同样经营困难。保险公司收了保费之后，包括系统的建设、营销的费用，最终发现自己也很难做到营利。</p><h4>服务无法与消费者支出匹配</h4><p>上述不愿具名的保险研究学者告诉时代周报记者，造成现在这种状况，监管与机构都有责任，首先监管层没有业外监管的权利，而且对于业务监管可能存在一些不到位的问题。个别大型保险公司由于此前盈利水平较好，因此在营销费用上更加财大气粗，中小公司为了获客，只能付出更高的成本，这也不难理解，为何车险公司的综合成本率居高难下，费率市场化试点以后，行业的获客成本进一步上升；另一方面则是保费的下降，长此以往，保险公司自然也将处在夹缝中生存，经营状况堪忧。如此一来，保险公司获取的保费对应的服务无法与消费者支出匹配。 除了线下渠道以外，一些线上的平台也开始参与车险整个链条，近年来包括车车、ok车险、最惠保等比价平台进入人们的视线。在张学辉看来，单纯的比价，补贴在车险领域很难立住脚跟，因为购买车险是低频事件，一年一次，通过补贴并不能增强客户的黏性，最终还是取决于线下服务，凡是有理赔经验的客户都会发现，他们更倾向选择服务方便、声誉好的公司投保，车险的核心竞争力在于服务体验，而不是单纯的比较价格。而如今，各路资本对于车险比价平台分外冷静。“比价只是开始的切入点，甚至是一个噱头，最惠保已经转型为交易服务平台。”最惠保创始人陈文志告诉时代周报记者，面对6200多亿元保费，第三方互联网平台依然力量很弱，保费占比不及千分之一，甚至可以忽略不计。传统保险公司销售渠道，不管是线下服务商，还是通过电话销售、代理人销售，都需要负担巨大的销售成本，总体的成本约占三成，由于车险又是相对标准化的产品，中国平安(行情601318,买入)、人保、太保等多家公司很早就开始尝试在互联网上去直销保险，互联网车险也在快速增长，去年年底，32家经营互联网车险的财险公司，保费达到716亿元，而2012年这一数据仅为101亿元。“传统的代理渠道流程很长，而且目前线下渠道竞争十分激烈，我们通过互联网比价平台，降低购买的流程，从另一角度而言，保险公司自身建立电销、网销营销中心，投入很大，大量的重复建设，通过第三方的互联网平台也降低了保险公司的管理与营销成本。”陈文志在接受时代周报记者采访时表示。陈文志还补充道，搭建这样一个平台，是想让业务员以及用户有一个较好的询价以及在线交易。比价不是最重要的，业务员很辛苦，而且不知道车险底价是多少，因为不同公司、不同地区的计算模型不尽相同，业务员需要通过不同保险公司问价，效率不高，而比价平台的成立帮助这些人更好地在线比价以及交易。一位互联网保险公司创业负责人则认为，互联网车险的发展一定不能局限在比价、购买这一环节，而是要将购买、理赔、其他服务垂直化，目前已经有科技公司在尝试将线下服务的场景与各家公司的产品之间打通，用户在选择产品时将不再局限于价格的标准，同样可以按照自己的需求，比如说服务网点的便利性等进行选择。对此，张学辉建议，汽车行业比较特别，汽车后市场最好只抓一个点展开，要想进行打通布局，要么至少掌握客户、要么掌握技术，要么掌握渠道，任何一端没强有力的推动，在这个行业当中难有竞争力。“现阶段并不主要考虑盈利模式。”陈文志还指出，与各家公司合作方式也不尽相同，对于通过最惠保平台交易的车险，平台只是分享一小部分代理人的回报， 有了数据、用户之后，平台将不仅限于比价，而是想做更专业的事情，比如帮保险公司更好地进行风险选择、制定风险准则，在理赔上帮助保险公司防欺诈，进行产品创新、产品研发等，甚至是与保险公司联合开发市场需求不足的产品。然而在比价平台兴起之出，也遭到一些保险公司的抵制，同样是担心这些网络平台客户量增加以后，提高引流费用。对此，上述不愿具名的保险研究学者指出，车险以及其他行业很多人都想去颠覆别人，看好别人碗里的肉。但想要让车险这个行业更健康地发展，只有协作。协作包括这种心态的平和，同业机构之间不仅是竞争，当然短期内这种状态很难达成，这需要企业提升自身的责任意识，而不是单纯地抢占市场，搞乱市场环境，也许接下来的竞争会让一些公司死掉，而这种环境下同业的其他公司很难从这一过程中获益。</p><h4>顶层设计标准要先行</h4><p> 在上述财险公司高层看来，目前车险行业已经进入一个怪圈，比如打麻将，人们最终发现，玩牌的都亏钱，只有提供场所和服务的棋牌室赚钱，车险行业还不尽相同，保险公司（搭建系统以及提供服务）相当于棋牌室，最终却要面临亏钱。整个车险的费用当中，有30%甚至更高是用作渠道费用。保险公司也曾想摆脱渠道的制约，但面临业务增长的压力，想要做大市场，只好委曲求全。然而，这种选择似乎让财险公司走入了一个死胡同，如今费率市场化仍在扩容，尽管赔付率有所下降，但竞争也在进一步加剧，导致渠道费用进一步提高，而整体上车险费率却在下降。与此同时，在激烈的竞争中，保险公司为了占据市场，在核保环节不够谨慎，这也是原因之一，如果投保环节宽松，理赔管理的成本自然会上升。这一现状能否破？销售渠道方面，互联网渠道或许值得进一步探索，将传统车险切割为各种个性化场景去满足不同消费者的个性化需求。除了保险公司的网销以外，像BAT以及一些互联网创业公司也在根据不同场景需求，对车险业务展开布局，未来或许会掀起波澜。对于保险公司而言，有必要加强风险选择，避免一些道德风险事件，即本不该赔付的事件却由保险来买单。上述互联网保险公司创业负责人告诉时代周报记者，未来我们除了要打通车险整个服务链，还要在发展中真正做到风险前置，在前端风险选择中严格筛选。鼓励公司进行精细化经营，同样提高公司的业务质量，使公司经营管理更为高效。事实上，早在2003年1月，第一次车险费率市场化开启后，各家保险公司就将车险费率整体下调了10%-15%，有的保险公司费率的最高降幅甚至超过30%。让车险整个行业亏损加剧，最终行业出台的最低限价，才引导行业向健康的方向发展。不难想象，如果费率降到一定幅度，与之对应的必然是服务质量的下降，从而引发消费者不满意，对于保险公司的口碑形成不利影响，新一轮的车险费率市场化如何避免历史的重演，监管职责首当其冲。在张学辉看来，目前对车险行业而言，顶层设计标准要先行，监管层只有制定统一的规则标准，加大业内监管的力度，才能使行业健康有序地发展。保险行业作为经营风险的特殊行业，具有社会管理职能，费率市场化的前提应有基础费率，由行业提出。因此，费率要市场化要有基准的市场化，也要有社会管理的职能。作为保险公司而言，同业机构找准定位，差异经营，各家公司最好根据股东业务及渠道特点，找准自己的定位，精细化经营。</p><p>美好的时刻总是那么的短暂，活动庆典在历经三个多小时后到达了尾声，虽然这次相聚的时间有限，但是我们相信嘉信保险经纪平阴分公司在未来发展的道路上，始终会秉承“做平阴市场最专业的经纪公司，为客户选择最好的产品和最优质的服务”，并坚信嘉信平阴分公司会越走越远，越做越好！</p>'
  }, {
    id: 2,
    img: newImg2,
    title: '乡村振兴战略下农村保险市场前景...',
    summary: ' 近日，中共中央政治局召开会议，审议《乡村振兴战略规划(2018-2022年)》和《关于打赢脱贫攻坚战三年行动的指导意见》。会议指出，...',
    dateTime: '2018-09-01',
    content: ''
  }, {
    id: 3,
    img: newImg3,
    title: '以税延优惠政策为契机 全面构建...',
    summary: '近日,银保监会等部门发布《个人税收递延型商业养老保险产品开发指引》,明确税延型养老险的设计原则、交费方式、收益...',
    dateTime: '2018-09-01',
    content: ''
  }],
  caseSource: [{
    id: 1,
    img: casePic1,
    title: '看病难，贵，有我无忧',
    summary: '俗话说，久病床前无孝子，如果没有足够的经济能力，这些家庭岌岌可危。',
    content: '',
    dateTime: '2018-09-01'
  }, {
    id: 2,
    img: casePic2,
    title: '发生意外，多一份保障',
    summary: '生活总是避免不了意外发生，当不幸来临时,谁来替你守护心爱的人...',
    content: ' ',
    dateTime: '2018-09-01'
  }, {
    id: 3,
    img: casePic3,
    title: '生活，因我更美',
    summary: '保险就好比是桥上的栏杆，有了不一定会扶，没有又不敢过桥...',
    content: '',
    dateTime: '2018-09-01'
  }]

}

let newsSource = [{
  id: 1,
  img: newImg1,
  title: '车险费改再陷怪圈 肉都被渠道吃了...',
  summary: '4月中下旬，多份涉及车险费率市场化改革的文件已下发至保险公司，而在前期两批共18个地区试点之后，商业车险费率改革有望全国铺开。去年6月1日起，...',
  dateTime: '2018-09-01',
  content: '<p>4月中下旬，多份涉及车险费率市场化改革的文件已下发至保险公司，而在前期两批共18个地区试点之后，商业车险费率改革有望全国铺开。</p><p> 去年6月1日起，黑龙江、山东等首批6个试点地区试行商业车险改革，今年年初已将试点铺向第二批12个地区。费率改革最早的试点已经接近一年。今年一季度成绩单显示，前十大车险公司的集中度在下降，一季度，首批试点地区车险保费收入为258.66亿元，同比增长11.30%，车险综合成本率同比下降1.32个百分点为94.18%，第二批试点地区车险保费收入为590.90亿元，同比增长12.12%，车险综合成本率为94.37%，同比下降1.66个百分点，较试点前下降2.26个百分点。 不错的成绩单背后，面对6200亿元的车险市场，保险公司有苦说不出，超九成公司车险业务亏损。一位不愿具名的财险公司高层表示，车险费改以来，车的保费在下降，但费用却在上升，而且最近一阶段上升得非常快，目前阶段，公司十分重视理赔，这一环节甚至决定了公司的生死。 消费者、修理厂、配件商甚至保险公司对现状都不满意，正如上述财险公司高层所言，保险公司提供了各项服务，仍然挣扎在亏损的边缘。车险行业综合费用率在30%-40%的区间，保费的30%以上作为渠道费用，个别公司付出的渠道费用甚至达到50%以上，费率市场化在一定程度上加剧市场竞争，使渠道费用进一步加重。“目前对车险行业而言，顶层设计标准要先行，监管层只有制定统一的规则标准，加大业内监管的力度。”中国市场学会风险管理专业委员会主任张学辉在接受时代周报记者采访时指出。另一位不愿具名的保险研究学者则表示，“要想解决目前的困局，还有一个思路，保险公司要转变盈利点，即通过车险等业务获得一个现金流，更多专注于投资来提高收益，而不仅是从保费中赚钱”。</p><h4> 各方不满现状</h4> <p>保监会发布的数据显示，2016年第一季度，首批试点地区车险综合成本率为94.18%，同比下降1.32个百分点，较试点前下降2.09个百分点；第二批试点地区车险综合成本率为94.37%，同比下降1.66个百分点，较试点前下降2.26个百分点。面对这平稳的数据，一位大型财险公司车险业务人员对时代周报记者直言，这或许只是表面上的平静。上述财险公司高层表示，车险费改试点实施后，保险公司的经营状况与此前设想的甚至相反，保费是下降了，但是费用却上升了，而且上升得非常快。来自一份业内交流数据显示，2016年1月，车险综合成本率100.6%，同比上升0.91个百分点；综合赔付率56.81%，同比下降5.44个百分点；综合费用率43.79%，同比上升6.35个百分点；直到3月，这一数据也并无明显变化，综合成本率99.16%，综合赔付率58.14%，综合费用率41.02%。今年1月，也是第二批费改试点的开局之际，保险公司也许想借此抓住宣传窗口期。综合费用率上升，最主要原因是各家公司通过高额补贴来占据市场，其中补贴包括中介的手续费、业务员的激励以及客户的补贴等。该人士举例称，由于部分4S店的新车用户较多，从而形成较高的议价能力，保险公司不想放弃新车保单这一块，就会抬高渠道费，山东甚至河北等个别地区，销售渠道可获得的返点甚至达到50%-55%。 行至今年3月，车险行业综合成本率降至99.16%，理赔部门做了相当大的努力，上述大型财险公司车险业务人员也告诉记者，今年以来，理赔工作尤其难做，这一块比以往不断趋严。上述管理层甚至直言，车险公司从未如此重视理赔这一环节，理赔的同事基本天天加班，领导层也在不断施加压力，因为这一环节已经决定了保险公司未来的命运。尽管如此，目前大家的努力却未得到各方的满意，消费者、修理厂、配件商甚至保险公司，他们对于现状都不满意。首先是消费者，认为我交了1000元的保费当中，有三四百元是其他费用，这个费用对自身而言公平吗？真正用于赔付的可能只有五六百元，消费者者不愿为其他费用买单，而修理厂同样经营困难。保险公司收了保费之后，包括系统的建设、营销的费用，最终发现自己也很难做到营利。</p><h4>服务无法与消费者支出匹配</h4><p>上述不愿具名的保险研究学者告诉时代周报记者，造成现在这种状况，监管与机构都有责任，首先监管层没有业外监管的权利，而且对于业务监管可能存在一些不到位的问题。个别大型保险公司由于此前盈利水平较好，因此在营销费用上更加财大气粗，中小公司为了获客，只能付出更高的成本，这也不难理解，为何车险公司的综合成本率居高难下，费率市场化试点以后，行业的获客成本进一步上升；另一方面则是保费的下降，长此以往，保险公司自然也将处在夹缝中生存，经营状况堪忧。如此一来，保险公司获取的保费对应的服务无法与消费者支出匹配。 除了线下渠道以外，一些线上的平台也开始参与车险整个链条，近年来包括车车、ok车险、最惠保等比价平台进入人们的视线。在张学辉看来，单纯的比价，补贴在车险领域很难立住脚跟，因为购买车险是低频事件，一年一次，通过补贴并不能增强客户的黏性，最终还是取决于线下服务，凡是有理赔经验的客户都会发现，他们更倾向选择服务方便、声誉好的公司投保，车险的核心竞争力在于服务体验，而不是单纯的比较价格。而如今，各路资本对于车险比价平台分外冷静。“比价只是开始的切入点，甚至是一个噱头，最惠保已经转型为交易服务平台。”最惠保创始人陈文志告诉时代周报记者，面对6200多亿元保费，第三方互联网平台依然力量很弱，保费占比不及千分之一，甚至可以忽略不计。传统保险公司销售渠道，不管是线下服务商，还是通过电话销售、代理人销售，都需要负担巨大的销售成本，总体的成本约占三成，由于车险又是相对标准化的产品，中国平安(行情601318,买入)、人保、太保等多家公司很早就开始尝试在互联网上去直销保险，互联网车险也在快速增长，去年年底，32家经营互联网车险的财险公司，保费达到716亿元，而2012年这一数据仅为101亿元。“传统的代理渠道流程很长，而且目前线下渠道竞争十分激烈，我们通过互联网比价平台，降低购买的流程，从另一角度而言，保险公司自身建立电销、网销营销中心，投入很大，大量的重复建设，通过第三方的互联网平台也降低了保险公司的管理与营销成本。”陈文志在接受时代周报记者采访时表示。陈文志还补充道，搭建这样一个平台，是想让业务员以及用户有一个较好的询价以及在线交易。比价不是最重要的，业务员很辛苦，而且不知道车险底价是多少，因为不同公司、不同地区的计算模型不尽相同，业务员需要通过不同保险公司问价，效率不高，而比价平台的成立帮助这些人更好地在线比价以及交易。一位互联网保险公司创业负责人则认为，互联网车险的发展一定不能局限在比价、购买这一环节，而是要将购买、理赔、其他服务垂直化，目前已经有科技公司在尝试将线下服务的场景与各家公司的产品之间打通，用户在选择产品时将不再局限于价格的标准，同样可以按照自己的需求，比如说服务网点的便利性等进行选择。对此，张学辉建议，汽车行业比较特别，汽车后市场最好只抓一个点展开，要想进行打通布局，要么至少掌握客户、要么掌握技术，要么掌握渠道，任何一端没强有力的推动，在这个行业当中难有竞争力。“现阶段并不主要考虑盈利模式。”陈文志还指出，与各家公司合作方式也不尽相同，对于通过最惠保平台交易的车险，平台只是分享一小部分代理人的回报， 有了数据、用户之后，平台将不仅限于比价，而是想做更专业的事情，比如帮保险公司更好地进行风险选择、制定风险准则，在理赔上帮助保险公司防欺诈，进行产品创新、产品研发等，甚至是与保险公司联合开发市场需求不足的产品。然而在比价平台兴起之出，也遭到一些保险公司的抵制，同样是担心这些网络平台客户量增加以后，提高引流费用。对此，上述不愿具名的保险研究学者指出，车险以及其他行业很多人都想去颠覆别人，看好别人碗里的肉。但想要让车险这个行业更健康地发展，只有协作。协作包括这种心态的平和，同业机构之间不仅是竞争，当然短期内这种状态很难达成，这需要企业提升自身的责任意识，而不是单纯地抢占市场，搞乱市场环境，也许接下来的竞争会让一些公司死掉，而这种环境下同业的其他公司很难从这一过程中获益。</p><h4>顶层设计标准要先行</h4><p> 在上述财险公司高层看来，目前车险行业已经进入一个怪圈，比如打麻将，人们最终发现，玩牌的都亏钱，只有提供场所和服务的棋牌室赚钱，车险行业还不尽相同，保险公司（搭建系统以及提供服务）相当于棋牌室，最终却要面临亏钱。整个车险的费用当中，有30%甚至更高是用作渠道费用。保险公司也曾想摆脱渠道的制约，但面临业务增长的压力，想要做大市场，只好委曲求全。然而，这种选择似乎让财险公司走入了一个死胡同，如今费率市场化仍在扩容，尽管赔付率有所下降，但竞争也在进一步加剧，导致渠道费用进一步提高，而整体上车险费率却在下降。与此同时，在激烈的竞争中，保险公司为了占据市场，在核保环节不够谨慎，这也是原因之一，如果投保环节宽松，理赔管理的成本自然会上升。这一现状能否破？销售渠道方面，互联网渠道或许值得进一步探索，将传统车险切割为各种个性化场景去满足不同消费者的个性化需求。除了保险公司的网销以外，像BAT以及一些互联网创业公司也在根据不同场景需求，对车险业务展开布局，未来或许会掀起波澜。对于保险公司而言，有必要加强风险选择，避免一些道德风险事件，即本不该赔付的事件却由保险来买单。上述互联网保险公司创业负责人告诉时代周报记者，未来我们除了要打通车险整个服务链，还要在发展中真正做到风险前置，在前端风险选择中严格筛选。鼓励公司进行精细化经营，同样提高公司的业务质量，使公司经营管理更为高效。事实上，早在2003年1月，第一次车险费率市场化开启后，各家保险公司就将车险费率整体下调了10%-15%，有的保险公司费率的最高降幅甚至超过30%。让车险整个行业亏损加剧，最终行业出台的最低限价，才引导行业向健康的方向发展。不难想象，如果费率降到一定幅度，与之对应的必然是服务质量的下降，从而引发消费者不满意，对于保险公司的口碑形成不利影响，新一轮的车险费率市场化如何避免历史的重演，监管职责首当其冲。在张学辉看来，目前对车险行业而言，顶层设计标准要先行，监管层只有制定统一的规则标准，加大业内监管的力度，才能使行业健康有序地发展。保险行业作为经营风险的特殊行业，具有社会管理职能，费率市场化的前提应有基础费率，由行业提出。因此，费率要市场化要有基准的市场化，也要有社会管理的职能。作为保险公司而言，同业机构找准定位，差异经营，各家公司最好根据股东业务及渠道特点，找准自己的定位，精细化经营。</p>'
}, {
  id: 2,
  img: newImg2,
  title: '乡村振兴战略下农村保险市场前景...',
  summary: ' 近日，中共中央政治局召开会议，审议《乡村振兴战略规划(2018-2022年)》和《关于打赢脱贫攻坚战三年行动的指导意见》。会议指出，...',
  dateTime: '2018-09-01',
  content: ''
}, {
  id: 3,
  img: newImg3,
  title: '以税延优惠政策为契机 全面构建...',
  summary: '近日,银保监会等部门发布《个人税收递延型商业养老保险产品开发指引》,明确税延型养老险的设计原则、交费方式、收益...',
  dateTime: '2018-09-01',
  content: ''
}]
export default {
  name: "index",
  data() {
    return {
      newData: [],
      topImg:false
    }
  },
  mounted() {
    let type = this.$route.query.type
    let tempArry = type == 'news' ? dataSource.newsSource : dataSource.caseSource
    tempArry.map((item) => {
      if (item.id == this.$route.query.id) {
        this.newData = item
        if(item.img&&item.img!=''){
          this.topImg=true
        }
      }
    })
  }
}
</script>
<style scoped lang="less" src="../../../style/index.less"></style>
<style scoped lang="less">
@media screen and (max-width: 767px) {
  .container {
    padding: 0;
    h3 {
      font-size: 18px;
      padding: 20px 20px 0;
    }
    .address {
      padding: 0;
      font-size: 14px;
    }
    .article{
      overflow: hidden;
    }
  }
}
@media screen and (min-width: 768px) {
  .container {
    padding: 50px 0;
    h3 {
      font-size: 24px;
    }
    .address {
      font-size: 18px;
    }
    .article{
       img{
         overflow: hidden;
       } 
    }
  }
}

.container {
  padding: 56px 0;
  font-size: 14px;
  color: #666666;
  h3 {
    color: #333333;
    font-weight: 400;
    text-align: center;
  }
  .img {
    height: 250px;
    width: 220px;
    margin: 10px auto;
  }
  .subTitle {
    text-align: center;
    color: #999999;
    padding: 10px 0;
  }
  .content {
    padding: 0 20px;
    line-height: 32px;
    h4 {
      color: #333333;
      padding: 10px 0;
      font-weight: 600;
    }
    p{
      line-height: 28px;
      &:not(.summary) {
        text-indent: 20px;
      }
    }
    .summary {
      color: #333333;
      padding: 10px 0;
      border-top: 1px dashed #eaeaea;
      border-bottom: 1px dashed #eaeaea;
      margin-bottom: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/News/NewsDetail/index.vue